module.exports = __webpack_public_path__ + "static/bfp_slide_collaboration-231447243166af9a9dcc045d4806055c.jpg";